import { render } from "./MiezzForm.vue?vue&type=template&id=2ba162a8&ts=true"
import script from "./MiezzForm.vue?vue&type=script&lang=ts"
export * from "./MiezzForm.vue?vue&type=script&lang=ts"

import "./MiezzForm.vue?vue&type=style&index=0&id=2ba162a8&lang=sass"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__